module.exports = __webpack_public_path__ + "static/media/leftAngle.d9e7e0f2.svg";